/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PartnerOrderInformationRequest} from '@cash-web/protos/squareup/disputes/partner/api/PartnerOrderInformation.pb'
import {PartnerOrderInformationResponse} from '@cash-web/protos/squareup/disputes/partner/api/PartnerOrderInformation.pb'


export const partnerOrderInformation = (request: PartnerOrderInformationRequest, options?: CashRequestOptions) => post<PartnerOrderInformationRequest, PartnerOrderInformationResponse>("/2.0/cash/partner-order-information", request, {...options, rejectOnError: true })